<template>
	<div class="container " v-loading.fullscreen="loading">
        <div class="top_path">
            <span @click="linkToFeedback">意见反馈 <i class="feedback-icon"></i> </span>
            <span @click="linkToGoUpDetail">更新公告 <i class="horn-icon"></i> </span>
            <span class="version_go_up" @click="linkToGoUpDetail">{{version_content}}</span>
            <div class="rate_path">
                <span v-for="(item,index) in rateList" :key="index">{{item.name}}({{item.symbol}}) : {{item.rate}}</span>
            </div>
        </div>
        <div class="content">
            <div>
                <p class="path_title bt">待办事项</p>
                <div class="box_path">
					<div :class="['box',module.indexOf(','+item.code+',')==-1?'lock':'']" v-for="(item,index) in todo" :key="index" @click="module.indexOf(','+item.code+',')!=-1?jumpPage(item.name,index):''">
                        <div class="box_number">{{item.value}}</div>
                        <p class="box_text">{{item.name}}</p>
                    </div>
                </div>
                <p class="path_title path_title_N_box">
                    <span :class="['path_title_N',seeType==2?'path_title_N_checked':'',total<=0?'path_title_N_N':'']" @click="seeType=2">库存预警</span><span v-if="total>0" class="path_title_number">{{total}}</span> 
                    <span :class="['path_title_N',seeType==3?'path_title_N_checked':'']" @click="seeType=3" v-if="module.indexOf(',finance,')!=-1">付款预警</span><span v-if="totalT>0" class="path_title_number">{{totalT}}</span> 
                    <!-- <i class="small-bell-icon"></i> -->
                </p>
                <section class="flex_path">
                    <section class="" style="display: flex;flex-direction: column;">
                        <div class="table_path home_table_path" v-if="seeType==2">
                            <el-table :data="tableData" style="width: 100%" size="mini" header-cell-class-name="home_table_th">
                                <el-table-column prop="alert_status_text" label="状态">
                                    <template slot-scope="scope">
                                        <span class="danger">{{ scope.row.alert_status_text }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="breed" show-overflow-tooltip label="品名"></el-table-column>
                                <el-table-column prop="grade" show-overflow-tooltip label="等级"></el-table-column>
                                <el-table-column prop="original_thickness" show-overflow-tooltip label="厚度"></el-table-column>
                                <el-table-column prop="original_length" show-overflow-tooltip label="长度"></el-table-column>
                                <el-table-column prop="min_stocks" show-overflow-tooltip label="最低库存"></el-table-column>
                                <el-table-column prop="max_stocks" show-overflow-tooltip label="最高库存"></el-table-column>
                                <el-table-column prop="total_cube" show-overflow-tooltip label="当前库存">
                                    <template slot-scope="scope">
                                        <span class="danger">{{ scope.row.total_cube }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="" style="margin-top:10px; text-align:center;">
                                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
                            </div>
                        </div>
                        <div class="table_path home_table_path" v-if="seeType==3">
                            <el-table :data="tableDataT" style="width: 100%" size="mini" header-cell-class-name="home_table_th">
                                <el-table-column width="120px" show-overflow-tooltip prop="contract_time" label="合同日期">
                                    <template slot-scope="scope">
                                        {{scope.row.contract_time}}
                                    </template>
                                </el-table-column>
                                <el-table-column width="120px" show-overflow-tooltip prop="expected_arrival_time" label="预计到港"></el-table-column>
                                <el-table-column width="175px" show-overflow-tooltip prop="contract_no" label="合同号"></el-table-column>
                                <el-table-column width="150px" show-overflow-tooltip prop="supplier" label="供应商"></el-table-column>
                                <el-table-column width="100px" show-overflow-tooltip prop="breed" label="品名"></el-table-column>
                                <el-table-column width="100px" show-overflow-tooltip prop="thickness" label="厚度"></el-table-column>
                                <el-table-column width="120px" show-overflow-tooltip prop="foreign_currency_name" label="币种"></el-table-column>
                                <el-table-column width="120px" show-overflow-tooltip prop="payer" label="付款方">
                                    <template slot-scope="scope">
                                        {{scope.row.payer}}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column width="100px" show-overflow-tooltip prop="foreign_currency_amount" label="外币金额">
                                    <template slot-scope="scope">
                                        {{scope.row.foreign_currency_amount}}
                                    </template>
                                </el-table-column> -->
                                <!-- <el-table-column width="120px" show-overflow-tooltip prop="payer" label="付款方"></el-table-column> -->
                            </el-table>
                            <div class="" style="margin-top:10px; text-align:center;">
                                <pagination ref="paginationT" :lastpages.sync="last_pageT" :currentpages.sync="current_pageT" :all.sync="totalT" :pagesizes.sync="params_T.per_page" @getPage="getPageT"></pagination>
                            </div>
                        </div>
                        <div class="bar_chart">
							<div class="bar_chart_header">
								<h3 class="path_title path_title_N_box">销售排行</h3>
								<div class="filter_row">
									<div class="">
										<el-button size="customize" :type="bar_params.type == 1 ? 'danger' : 'default'" @click.native="bar_params.type = 1">商品</el-button>
										<el-button size="customize" :type="bar_params.type == 0 ? 'danger' : 'default'" @click.native="bar_params.type = 0">销售员</el-button>
									</div>
									<div class="box_goods">
										<span class="item" :class="bar_params.date == 0 ? 'active' : ''" @click='bar_params.date = 0'>本月</span>
										<span class="item" :class="bar_params.date == 1 ? 'active' : ''" @click='bar_params.date = 1'>上一月</span>
										<span class="item" :class="bar_params.date == 2 ? 'active' : ''" @click='bar_params.date = 2'>上一周</span>
									</div>
								</div>
							</div>
                            <div class="" id="bar_chart"></div>
                        </div>
                    </section>
                    <div class="pie_chart">
                        <p class="path_title">库存分析</p>
                        <ul class="cart_list">
                            <li :class="pie_params.type == 'age' ? 'active' : ''" @click="pie_params.type = 'age'">库龄</li>
                            <li :class="pie_params.type == 'breed' ? 'active' : ''" @click="pie_params.type = 'breed'">商品</li>
                            <li :class="pie_params.type == 'warehouse' ? 'active' : ''" @click="pie_params.type = 'warehouse'">仓库</li>
                        </ul>
                        <div class="" id="pie_chart"></div>
                    </div>
                </section>
            </div>
            <div class="commonly_used">
                <p class="path_title">常用功能</p>
                <ul class="cu_lsit">
                    <li @click="jumpPageC('现货库存','saleStock')" v-if="module.indexOf(',sell-report-stock,')!=-1">
						<i class="right1-icon"></i>
                        <span>现货库存</span>
                    </li>
                    <li @click="jumpPageC('在途资源','purchaseMidway')" v-if="module.indexOf(',purchase-report-road,')!=-1">
						<i class="right2-icon"></i>
                        <span>在途资源</span>
                    </li>
                    <li @click="jumpPageC('销售单','saleOrder')" v-if="module.indexOf(',sell-item,')!=-1">
						<i class="right3-icon"></i>
                        <span>销售单</span>
                    </li>
                    <li @click="jumpPageC('采购订单','purchaseList')" v-if="module.indexOf(',purchase-order,')!=-1">
						<i class="right4-icon"></i>
                        <span>采购订单</span>
                    </li>
                    <li @click="jumpPageC('直接入库','purchaseWarehouse')" v-if="module.indexOf(',purchase-in,')!=-1">
						<i class="right5-icon"></i>
                        <span>直接入库</span>
                    </li>
                    <li @click="jumpPageC('销售统计','saleStatistics')" v-if="module.indexOf(',sell-report-statistic,')!=-1">
						<i class="right6-icon"></i>
                        <span>销售统计</span>
                    </li>
                    <li @click="jumpPageC('库存管理','warehouseStatistics')" v-if="module.indexOf(',warehouse-statistic,')!=-1">
						<i class="right7-icon"></i>
                        <span>库存管理</span>
                    </li>
                    <li @click="jumpPageC('库存预警','warehouseReportAdvance')" v-if="module.indexOf(',setting-base-inventory-alert,')!=-1">
						<i class="right8-icon"></i>
                        <span>库存预警</span>
                    </li>
                    <li v-if="module.indexOf(',shop-shop-manage,')!=-1">
						<i class="right9-icon"></i>
                        <span>店铺管理</span>
                    </li>
                    <li v-if="module.indexOf(',data,')!=-1">
						<i class="right10-icon"></i>
                        <span>数据分析</span>
                    </li>
                </ul>
            </div>
        </div>
        <dingtalk></dingtalk>
        <el-dialog title="" :visible.sync="versionDetailVisible" :close-on-click-modal='false' @close="handleCloseEvent" width="500px" top="35vh">
            <div class="version_title" style="font-weight: bold;">
                {{version_content}}
                <el-rate style="display: inline-block;" v-model="star_level" disabled text-color="#ff9900"></el-rate>
            </div>
            <div class="version_content">{{sub_title}}</div>
            <div class="version_date">{{goUpDate}}</div>
            <span slot="footer" class="dialog-footer version_detail">
                <el-button @click="linkToGoUpDetail" size="mini" type="primary">查看详情</el-button>
            </span>
        </el-dialog>
	</div>
</template>

<style scoped lang="scss">
    .rate_path{float: right;}
    .container{
        display: flex; flex-direction: column; height: 100%;
        .top_path{
            padding: 5px 18px; line-height: 1; text-align: left; font-size: 14px; color: #FF9100;
			& > span{
				display: inline-flex; align-items: center;
                & > i { margin-left: 5px;}
                 cursor: pointer;
			}
            span + span { margin-left: 27px; }
			.feedback-icon{ width: 15px; height: 15px; }
			.horn-icon{ width: 15px; height: 15px; }
            .version_go_up{
                display: inline-block;
                max-width: 350px;
                color: red;
               
                overflow:hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                position: relative;
                top: 2px;
            }
        }
        .content{
            flex: 1; background-color: #fff; margin-left: 12px; padding: 10px 20px 13px; text-align: left; display: flex; overflow: auto;
            & > div{ flex: 1; }

            .box_path{
                padding-top: 23px; white-space: nowrap; margin-bottom: 17px;
                .box{
                    display: inline-block; width: 240px; height: 128px; background: #FFFFFF; box-shadow:0px 3px 6px rgba(0,0,0,0.16); border-radius: 10px; overflow: hidden; padding: 20px 0 27px; text-align: center; cursor: pointer;
                    &:hover{  font-weight:bold; background: #FFB048; }
                    & + .box{ margin-left: 18px; }
                    .box_number{ font-size: 48px; line-height:55px; }
                    .box_text{ margin: 8px 0 0; line-height:20px; font-size:14px; }
                }
				.lock{
					position: relative; color: #888888; cursor: not-allowed;
					&::after{ display: block; content: ""; position: absolute; width: 50px; height: 51px; background: url("/icon/lock.png") no-repeat transparent; background-size: contain; bottom: 0; right: 0; }
					&:hover{ font-weight: normal; background: transparent; }
				}
            }

            .flex_path{
                display: flex;
                & > section{ flex: 1; margin-right: 11px; }
                .table_path{
                    width:1008px; height:287px; background: #FFFFFF; border:1px solid #D0D5E8; border-radius:3px; 
                }

                .bar_chart{
                    width:1010px; height:250px; background: #F6F7FB; border-radius:4px; margin-top: 3px; display: flex; flex-direction: column;
                    .bar_chart_header{
                        padding: 15px 15px 0 15px;
						.filter_row{
							display: flex; align-items: center; justify-content: space-between;
						}
						.box_goods{
							display: flex; align-items: center;
							.item{
								font-size:14px; font-weight:bold; line-height:20px; position: relative; cursor: pointer;
								&.active::after{ display: block; content:""; height:4px; border-radius:2px; background: #B21111; top: 100%; left: -3px; right: -3px; position: absolute; }
								& + .item{ margin-left: 35px; }
							}
						}
                    }
                    #bar_chart{ flex: 1; }
                }
            }

            .pie_chart{
                width: 510px; height: 555px; background: #F6F7FB; border-radius: 4px; padding: 20px 18px; display: flex; flex-direction: column;
                .cart_list{
                    display: flex; margin-top: 8px;
                    li{
                        font-size:16px; font-weight:bold; line-height:22px; color: #333333; text-align: center; cursor: pointer; position: relative; margin-bottom: 10px;
                        &.active::after{ display: block; content: ""; position: absolute; left: -3px; right: -3px; height:4px; background:#b21111; border-radius:2px; margin-top: 2px; }
                        & + li { margin-left: 50px; }
                    }
                }
                #pie_chart{ flex: 1; }
            }

            .commonly_used{
                display: flex; flex-direction: column; flex: none; width: 218px; border-radius: 4px; margin-left: 18px;height:793px;
                .cu_lsit{
                    background: #F6F7FB; padding: 20px; flex:1; overflow: auto; border-radius:4px; margin-top: 6px;
                    & > li{
						display: flex; align-items: center; padding-left: 25px;
                        width:180px; height:49px; box-shadow:0px 0px 4px rgba(85,85,85,0.16); border-radius:4px; background: #FFFFFF; cursor: pointer; border:1px solid transparent;
                        & + li { margin-top: 20px; }
                        &:hover{ border:1px solid #B21010; color: #B21111; }
						& > i{ margin-right: 20px; }
                    }
                }
            }
        }
        .path_title_N_box{padding-bottom:10px!important;}
        .path_title{
            font-size:18px; font-weight:bold; line-height:25px; color: #333333; padding-bottom: 2px; margin: 0; display: flex; align-items: center;
			.small-bell-icon{ margin-left: 10px; }
            &.bt{ border-bottom: 1px solid #CCCCCC; }
        }
        .home_table_path{margin-bottom:15px;}
        .path_title_N{margin-right:5px;cursor: pointer;}
        .path_title_N_N{margin-right:30px;}
        .path_title_N_checked{border-bottom:2px solid #B21111;}
        .path_title_number{display: inline-block;width:20px;height:20px;text-align: center;line-height: 20px;color: white;background-color: #b21111;border-radius: 50%;font-size: 13px;margin-right: 15px;}
    }

.container /deep/ .el-dialog__body{
    padding: 0 20px;
    .version_title{
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
    }
    .version_content{
        text-indent: 2em;
        text-align: left;
        margin-top: 20px;
        color: #999;
    }
    .version_date{
        text-align: right;
        margin: 20px 0;
        color: #999;
    }
    .version_detail{
        text-align: center;
    }
}
.container /deep/ .el-dialog__footer{
    text-align: center;
}
.container /deep/ .el-dialog__wrapper{
    background: rgba(0,0,0, .1);
}
.container /deep/ .el-rate__icon{
    margin-right: 0px;
    position: relative;
    top: -2px;
}
</style>

<script>
import pagination from '../components/pagination.vue'
export default {
	data() {
		return {
            module:localStorage.dw_erp_power_code,
            loading : false,
            params:{
                timeStart:"",
                timeEnd:"",
                per_page:5,
                page:1
            },
            params_T:{
                per_page:5,
                page:1
            },
			todo:[],
            last_page:0,
            current_page:1,
            page:0,
            total:0,
            last_pageT:0,
            current_pageT:1,
            pageT:0,
            totalT:0,
            tableData:[],
            tableDataT:[],
			bar_params:{
				date : 0,
				type : 1,
            },
            seeType:2,//2库存预警 3付款预警
            bar_chart:{},
			pie_params:{
				type : "age"
			},
            pie_chart:{},

            //公告
            version_content: '',
            versionDetailVisible: false,
            sub_title: '',
            goUpDate: '',
            star_level: 5,
            rateList:[],
		}
	},
    components:{
        pagination,
        'dingtalk': {
			render(createElement) {
				return createElement(
				    'script',
                    {
                        attrs: {
                            type: 'text/javascript',
                            src: "https://ykf-webchat.7moor.com/javascripts/7moorInit.js?accessId=5e4073d0-2ade-11ea-b32e-e5751ac7a114&autoShow=true&language=ZHCN' async='async'>",
                        },
				    },
				);
			},
		}
    },
	computed:{
	},
	created(){
        this.getWarning()
        this.getPayWarning()
        this.getRate()
	},
	mounted(){
		this.getTodo();
        this.getBarData();
        this.getPieData();
        // this.postFunc("/erp/user.login",{"company":"test","username": "admin","password": "7opjshme"},(res)=>{
        //     this.pl(res)
        // })
        this.getVersionDetail()
	},
	destroyed() {
	},
	methods: {
        getRate(){
            this.postFunc("/erp/currency.exchange.rate",{},res=>{
                this.rateList = res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getWarning(){
            this.postFunc("/erp/stock.alert.home",this.params,res=>{
                this.last_page=parseInt(res.data.data.last_page);
                this.params.page=parseInt(res.data.data.current_page);
                this.total=parseInt(res.data.data.total);
                this.tableData=res.data.data.data;
                this.$refs.pagination.flag = true;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getPayWarning(){
            this.postFunc("/erp/statement.pay.alert",this.params_T,res=>{
                this.last_pageT=parseInt(res.data.data.last_page);
                this.params_T.page=parseInt(res.data.data.current_page);
                this.totalT=parseInt(res.data.data.total);
                this.tableDataT=res.data.data.data;
                this.$refs.paginationT.flag = true;
                this.tableDataT.forEach((item,index)=>{
                    if(this.tableDataT[index].contract_time==0){
                        this.tableDataT[index].contract_time = "";
                    }else{
                        this.tableDataT[index].contract_time = this.formatTime(item.contract_time*1000)
                    }
                    if(this.tableDataT[index].expected_arrival_time==0){
                        this.tableDataT[index].expected_arrival_time = "";
                    }else{
                        this.tableDataT[index].expected_arrival_time = this.formatTime(item.expected_arrival_time*1000)
                    }
                    if(this.tableDataT[index].expected_shipping_time==0){
                        this.tableDataT[index].expected_shipping_time = "";
                    }else{
                        this.tableDataT[index].expected_shipping_time = this.formatTime(item.expected_shipping_time*1000)
                    }
                })

            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
		getTodo(){
			this.$axios.post("/erp/system.todo.item").then((response) => {
				if(response.data.code == 0){
                    let arrList = [];
                    response.data.data.forEach((item,index)=>{
                        if(item.code=='finance-doc-payment-customer' || item.code=='redeem-order-manage' || item.code =='purchase-report-road-instore' || item.code =='office-leave' ||item.code =='finance-fee-review'){
                            return
                        }else{
                            arrList.push(item);
                        }
                    })
					this.todo = arrList
				}
			}).catch((error) => {
				window.console.log(error);
			})
		},
        getPage(obj){
            this.params.page=obj.currentpage;
            this.params.per_page=obj.pagesize;
        },
        getPageT(obj){
            this.params_T.page=obj.currentpage;
            this.params_T.per_page=obj.pagesize;
        },
		getBarData(){
			let start_time = 0;
			let end_time = 0;
			let month = window.moment().month();
			// window.console.log("2020-01-12",window.moment("2020-01-12").weekday())
			switch (this.bar_params.date) {
				case 0:
					// start_time = window.moment().date(1).month(month).startOf('day').unix()
                    // end_time = window.moment().date(1).month(month + 1).subtract(1,"day").subtract(0,'hour').unix()
                    start_time = window.moment().startOf('month').unix()
					end_time = window.moment().endOf('month').unix()
					break;
				case 1:
					// start_time = window.moment().date(1).month(month - 1).unix()
                    // end_time = window.moment().date(1).month(month).subtract(1,"day").unix()
                    start_time = window.moment().month(month - 1).startOf('month').unix()
					end_time = window.moment().month(month - 1).endOf('month').unix()
					break;
				case 2:
                    // start_time = window.moment().subtract('days',7).unix()
                    // end_time = window.moment().subtract('days',1).unix()
                    start_time = window.moment().week(window.moment().week() - 1).startOf('isoWeek').unix()
					end_time = window.moment().week(window.moment().week() - 1).endOf('isoWeek').unix()
					break;
			}
			this.$axios.post("/erp/statement.sales",{
				type: this.bar_params.type,
				start_time: start_time,
				end_time: end_time,
			}).then((response) => {
				if(response.data.code == 0){
					// do something
					let data = response.data.data.map((item) => {
						return item.sales_cube;
					});
					let filed = response.data.data.map((item) => {
						if (item.hasOwnProperty('breed_name')) {
							return item.breed_name;
						}
						if (item.hasOwnProperty('salesman_name')) {
							return item.salesman_name;
						}

					});
					this.drawBar(filed, data);
				}
			}).catch((error) => {
				window.console.log(error);
			})
		},
        drawBar(filed, data){
            if (this.bar_chart.hasOwnProperty("id")) {
				this.bar_chart.dispose();
			}
			this.bar_chart = window.echarts.init(document.getElementById('bar_chart'));
            let option = {
                color: ['#3398DB'],
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : {
                    axisLine: {show: false},
                    type : 'category',
                    data : filed,
                    axisTick: {
                        alignWithLabel: true,
                    },
                },
                yAxis : {
                    splitLine: {show: false},
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {show: false},
                    type : 'value'
                },
                series : [
                    {
                        name:'销售总立方',
                        type: 'pictorialBar',
                        barCategoryGap: '-130%',
						symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
                        itemStyle: {
							normal: {
								opacity: 0.5
							},
						},
                        data:data,
                        z: 10
                    }
                ]
            };
            this.bar_chart.setOption(option);
        },
		getPieData(){
			this.$axios.post("/erp/inventory.stock.analysis",this.pie_params).then((response) => {
				if(response.data.code == 0){
					let data = JSON.parse( JSON.stringify(response.data.data) );
					let filed = [];
					data.forEach((item) => {
						filed.push(item.name)
					});
					this.drawPie(filed,data)
				}
			}).catch((error) => {
				window.console.log(error);
			})
		},
        drawPie(filed,data){
			if (this.pie_chart.hasOwnProperty("id")) {
				this.pie_chart.dispose();
			}
			this.pie_chart = window.echarts.init(document.getElementById('pie_chart'));
            let option = {
                color: ['#b21111','#ff7500', '#f2be45','#3d3b4f','#70f3ff','#4b5cc4','#9ed990','#c93756','#725e82','#16a951'],
                tooltip: {
                    trigger: 'item',
                    // formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    // orient: '',
                    x: 'left',
                    data: filed
                },
                series: [
                    {
                        // name:'访问来源',
                        type:'pie',
                        radius: ['0%', '30%'],
                        // avoidLabelOverlap: false,
                        data: data,
                        selectedMode: 'single',
						selectedOffset: 10,
						label:{
							formatter: '{b} {d}%',
						},
                    }
                ]
            };
			this.pie_chart.setOption(option);
		},
		jumpPage(name,index){
            // this.$root.$children[0].$children[0].jumpPage(name,index)
            let url = "";
            switch(index){
                case 0:
                    url = "saleReview";
                break;
                case 1:
                    url = "financeReceivable";
                break;
                case 2:
                    url = "warehouseComponentsReceivableReceivableOutbound";
                break;
                case 3:
                    url = "saleRefund";
                break;
                case 4:
                    url = "warehouseDocReturn";
                break;
                case 5:
                    url = "getMoneyRemind";
                break;
                case 6:
                    url = "purchaseMidwayBoard";
                    sessionStorage.setItem("PURCHASEMIDWAYBOARD",1)
                break;
            }
            let obj = new Object();
            obj.name=name;
            obj.label=name;
            obj.content=url;
            this.$root.$children[0].$children[0].showTab(obj)
        },
        jumpPageC(name,url){
            let obj = new Object();
            obj.name=name;
            obj.label=name;
            obj.content=url;
            this.$root.$children[0].$children[0].showTab(obj)
        },
        //跳转公告详情页面 并调用最新公告接口
        linkToGoUpDetail(){
            this.postFunc("erp/bulletin.latest",{}, ()=>{
                var obj={};
                obj.label="公告详情";
                obj.name="公告详情";
                obj.content="versionList";
                this.$emit("clickNewAdd",obj);
                this.versionDetailVisible = false
            })
        },
        //获取最新公告
        getVersionDetail(){
            this.postFunc("erp/bulletin.latest",{}, res=>{
                let resData = res.data.data
                if(resData.popup == 1){
                    this.versionDetailVisible = true
                }
                this.version_content = resData.main_title              
                this.goUpDate = resData.create_time ? this.formatTime(resData.create_time*1000) : ''
                this.sub_title = resData.sub_title
                this.star_level = resData.star_level
            })
        },
        handleCloseEvent(){
            this.postFunc("erp/bulletin.latest",{}, ()=>{})
        },
        //跳转反馈意见页面
        linkToFeedback(){
            var obj={};
            obj.label="意见反馈";
            obj.name="意见反馈";
            obj.content="feedback";
            this.$emit("clickNewAdd",obj);
        }
	},
	watch:{
		'pie_params.type':function(){
			this.getPieData();
		},
		'bar_params.date':function(){
			this.getBarData();
		},
		'bar_params.type':function(){
			this.getBarData();
        },
        "params.page":function(){
            this.getWarning();
        },
        "params.per_page":function(){
            this.getWarning();
        },
        "params_T.page":function(){
            this.getPayWarning();
        },
        "params_T.per_page":function(){
            this.getPayWarning();
        },
        "seeType":function(val){
            if(val==2){
                this.getWarning()
            }else if(val==3){
                this.getPayWarning()
            }
        }
	}
}
</script>
